import React, { useState, useEffect, Fragment } from 'react';
import { useFormikContext } from 'formik';
import { useFormikWizard } from 'formik-wizard';
import CommonOtpInput from '../CommonOtpInput/CommonOtpInput';
import { ThrowError } from '../../constants/ThrowError';
import { Append_0 } from '../../constants/Append_0';
import NewSpinner from '../../components/NewSpinner/NewSpinner';
import { otpContainer, otpInput } from './GlobalOTP.module.css';
import { navigate } from 'gatsby-link';
import PopUp from '../PopUp/PopUp';

const Otp = ({
  consumerSendOtp,
  header,
  itsBpOnBoarding,
  bpLogin,
  itsWalkinForm,
  mobileNo,
  emailAddress
}) => {
  const getMobNo = () => {
    let url = new URL(window.location);
    return url.searchParams.get('phone');
  };
  const getEmail = () => {
    let url = new URL(window.location);
    return url.searchParams.get('email');
  };

  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(null);
  const [canResend, setCanResend] = useState(true);
  const [timeLeft, setTimeLeft] = useState(60);
  const [timeLeftToResentOtp, setTimeLeftToResentOtp] = useState(10);
  const [errMsg, setErrMsg] = useState('');
  const [mobile, setMobileNo] = useState(mobileNo || getMobNo());
  const [email, setemail] = useState(emailAddress || getEmail());
  const [show, setShow] = useState(true);

  const { setFieldValue } = useFormikContext();
  if (!email && !mobile)
    return (
      <PopUp
        type="fail"
        text="The url is not vaild!"
        show={show}
        setShow={setShow}
      />
    );

  useEffect(() => {
    setFieldValue('mobile', mobile);
    setFieldValue('email', email);
  }, []);
  const countDown = () => {
    if (timeLeft > 0) {
      setTimeLeft(timeLeft => Append_0(timeLeft - 1, 2));
    }
  };
  useEffect(() => {
    let x = setInterval(() => countDown(), 1000);
    if (timeLeft === 0) clearInterval(x);
    return () => clearInterval(x);
  }, [timeLeft]);
  useEffect(() => {
    let y;
    if (loading !== null && !loading && timeLeftToResentOtp > -1) {
      if (timeLeftToResentOtp > 0)
        y = setInterval(() => {
          if (timeLeftToResentOtp > -1)
            setTimeLeftToResentOtp(timeLeftToResentOtp =>
              Append_0(timeLeftToResentOtp - 1, 2)
            );
        }, 1000);

      if (parseInt(timeLeftToResentOtp) === 0) {
        clearInterval(y);
        setCanResend(true);
      } else setCanResend(false);
    }
    return () => clearInterval(y);
  }, [loading, timeLeftToResentOtp]);

  const resendOtp = () => {
    consumerSendOtp({ phone: mobile, email: email }, 'MOBILE')
      .then(res => {
        setLoading(false);
        setTimeLeftToResentOtp(10);
      })
      .catch(err => {
        setLoading(false);
        setErrMsg(
          err?.response?.data?.message ||
            'something went wrong! Please try again'
        );
      });
  };
  return (
    <div
      className={
        (header ? '' : 'px-5 md:min-w-50v max-w-lg') + ' w-full  mx-auto py-5 '
      }
    >
      <p className="font-roboto font-normal  text-black-400 md:text-black-1011 text-xl my-3 text-center">
        {header ? header : 'Please enter the 4-digit PIN we just sent to +91-'}
        {!bpLogin
          ? [mobile].map(
              s =>
                s.slice(0, 2) +
                s.slice(2, 8).replace(/\d{5}$/, '*****') +
                s.slice(8)
            )
          : ''}
      </p>
      {timeLeft > 0 ? (
        <p className="text-grey-2232 font-roboto font-normal text-center ">
          OTP Expires in :
          <span className="font-roboto font-medium text-xl text-orange-1100">
            {` 00:${timeLeft}`}
          </span>
        </p>
      ) : (
        itsWalkinForm && (
          <button
            className=" underline sm:ml-3 mx-auto text-center items-center content-center w-full "
            type="submit"
            onClick={() => setFieldValue('skipOtp', true)}
          >
            Skip OTP
          </button>
        )
      )}

      <div
        className="text-center mx-auto mt-10"
        style={{ width: 'fit-content' }}
      >
        <CommonOtpInput
          length={4}
          className={otpContainer}
          inputClassName={otpInput}
          isNumberInput
          autoFocus
          onChangeOTP={otp => {
            setOtp(otp);
            setFieldValue('otp', otp, true);
            setErrMsg('');
          }}
        />
      </div>
      <ThrowError ErrMsg={errMsg} />
      <div className="mt-8">
        <button
          type="submit"
          onClick={() => setFieldValue('skipOtp', false)}
          disabled={otp.length != 4}
          className={(itsBpOnBoarding ? 'w-full' : 'w-56') + ' submitButton'}
        >
          Verify
        </button>
      </div>
      <div
        className={
          (loading || !canResend
            ? 'text-grey-300 cursor-not-allowed '
            : 'text-orange-1100 ') +
          ' relative  text-xs text-center font-roboto font-medium mx-auto mt-5 cursor-pointer '
        }
        style={{
          width: 'fit-content'
        }}
        onClick={() => {
          if (canResend) {
            setLoading(true);
            resendOtp();
            setTimeLeft(60);
            setErrMsg('');
          }
        }}
      >
        <p>
          Re-send OTP to{' '}
          {[mobile].map(
            s =>
              s.slice(0, 2) +
              s.slice(2, 8).replace(/\d{5}$/, '*****') +
              s.slice(8)
          )}
          {!canResend ? (
            <span className="text-black-200 ml-1 ">
              in
              <span className="text-black-0 font-bold ml-1 mr-1">
                {Append_0(timeLeftToResentOtp, 2)}
              </span>
              sec
            </span>
          ) : (
            ''
          )}
        </p>
        <span className="absolute top-0 inset-x-3/10">
          {loading && <NewSpinner />}
        </span>
      </div>
      <div className="text-grey-2232 font-roboto mt-2 text-xs text-center">
        {bpLogin
          ? 'OTP is a 4 digit code, check message inbox'
          : 'We will use this OTP to Verify your Phone number'}
      </div>
    </div>
  );
};

export default Otp;
